<template>
  <div id="posters">
    <poster-item
      v-for="item in posters"
      v-bind:poster="item"
      v-bind:key="item.id"
    ></poster-item>
  </div>
</template>

<script>
import PosterItem from '@/components/poster.vue'
import axios from 'axios'

export default {
  components: {
    PosterItem
  },
  data() {
    return {
      posters: null
    }
  },
  mounted(){
    axios.get('/posters.json').then(response => (this.posters = response.data.posters));
  }
}
</script>
